/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BannedItemBulkDeleteDTO interface.
 */
export function instanceOfBannedItemBulkDeleteDTO(value) {
    return true;
}
export function BannedItemBulkDeleteDTOFromJSON(json) {
    return BannedItemBulkDeleteDTOFromJSONTyped(json, false);
}
export function BannedItemBulkDeleteDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ids': json['ids'] == null ? undefined : json['ids'],
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'search': json['search'] == null ? undefined : json['search'],
    };
}
export function BannedItemBulkDeleteDTOToJSON(json) {
    return BannedItemBulkDeleteDTOToJSONTyped(json, false);
}
export function BannedItemBulkDeleteDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ids': value['ids'],
        'selectAll': value['selectAll'],
        'marketplace': value['marketplace'],
        'search': value['search'],
    };
}
